import React from 'react';
export default function RadioButton({
  labelClass,
  options,
  id,
  name,
  selectedOption,
  onOptionChange,
  className,
  disabled,
}: any) {
  const onChange = (e: any) => {
    onOptionChange(e);
  };
  return (
    <div>
      {options.map((item: string) => (
        <span key={`${id}_${item}`}>
          <input
            type="radio"
            id={id}
            key={id}
            name={name}
            value={item}
            className={className}
            checked={selectedOption === item}
            onChange={onChange}
            disabled={disabled}
          />
          <label htmlFor="html" className={labelClass}>
            {item}
          </label>
        </span>
      ))}
    </div>
  );
}
